export const referralUses = (state = 0, { type, payload }) => {
  if (type === 'SET_REFERRAL_USES') {
    return payload
  } else {
    return state
  }
}
